import { connect } from "react-redux";
import get from "lodash/get";

import {
  logIn as onLogIn,
  logInDemo as onLogInDemo,
  logOut as onLogOut,
  setLogin as onSetLogin,
  setLogout as onSetLogout,
  getOAuth2Prams as onGetOAuth2Prams,
  logInOAuth2 as onLogInOAuth2,
  clearAuthErrors as onClearAuthErrors,
} from "./../../actions/authActions";

const mapStateToProps = (state) => ({
  dataState: state.auth.dataState,
  data: get(state, ["auth", "data"], []),
  authState: get(state, ["auth", "authState"], false),
  errors: get(state, ["auth", "errors", "data"], null),
  errorsModel: get(state, ["auth", "errors", "data", "model"], null),
  errorsHeaders: {
    config: get(state, ["auth", "errors", "config"], {}),
    headers: get(state, ["auth", "errors", "headers"], {}),
    status: get(state, ["auth", "errors", "status"], {}),
    statusText: get(state, ["auth", "errors", "statusText"], {}),
    request: get(state, ["auth", "errors", "request"], {}),
  },
});

const mapDispatchToProps = {
  onLogIn,
  onLogInDemo,
  onGetOAuth2Prams,
  onLogInOAuth2,
  onLogOut,
  onSetLogin,
  onSetLogout,
  onClearAuthErrors,
};

const withAuth = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withAuth };
